import { Box, Text, Image } from '@chakra-ui/react';
import noInvoice from './../assets/no-invoice.png';

type Props = { tab: string };

const NoInvoiceDisclaimer = ({ tab }: Props): JSX.Element => {
  const title = `Aún no tienes ${tab.toLowerCase()}`;
  const subtitle = `Aquí podrás verlas cuando estén disponibles.`;
  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
      gap={6}
      maxWidth={'331px'}
      p={4}
      textAlign={'center'}
      mx={'auto'}
    >
      <Image src={noInvoice} boxSize={'79px'} />
      <Text fontWeight={500} fontSize={'1.75rem'} whiteSpace="normal" wordBreak="break-word">
        {title}
      </Text>
      <Text whiteSpace="normal" wordBreak="break-word">
        {subtitle}
      </Text>
    </Box>
  );
};

export default NoInvoiceDisclaimer;
